
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitopuneairportcab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Airport Cab',
        heading: 'S9 Travels:  Mumbai to Pune Airport Cab',
        headingDescription: 'S9 Travels offers reliable and comfortable Mumbai to Pune Airport cab services, ensuring a hassle-free journey for business travelers, families, and individuals. Covering a distance of approximately 150 km in around 3 to 3.5 hours, our well-maintained cabs and professional drivers provide a safe and smooth ride. With punctual service, comfortable seating, and excellent customer support, S9 Travels ensures a seamless travel experience from Mumbai to Pune Airport.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historic fortification in Pune, built in 1732. It was the seat of the Peshwas of the Maratha Empire. The fort is known for its majestic architecture, intricate carvings, and historical significance."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a historic landmark that played a crucial role in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his associates during the Quit India Movement. The palace is now a museum displaying various artifacts related to Gandhi’s life."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort is a historic site that offers breathtaking views of the surrounding landscape. It is known for its significance in Maratha history and is a popular trekking destination for adventure enthusiasts."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "This famous temple is dedicated to Lord Ganesha and attracts thousands of devotees every year. Known for its beautiful idol adorned with gold and jewelry, the temple is a must-visit for spiritual seekers and tourists alike."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. It is a significant architectural and historical site, offering a serene and spiritual experience."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This fascinating museum houses an extensive collection of artifacts, sculptures, musical instruments, and everyday objects from Indian history. It provides a glimpse into India’s rich cultural heritage."
    },
    {
      "title": "Vetal Tekdi",
      "description": "Vetal Tekdi is a popular hill in Pune known for its scenic beauty and trekking trails. It is an ideal spot for nature lovers and fitness enthusiasts looking for an early morning hike or a peaceful escape from the city."
    },
    {
      "title": "Pashan Lake",
      "description": "Pashan Lake is a tranquil artificial lake that serves as a great spot for birdwatching and leisurely walks. It’s a perfect place to unwind amidst nature and enjoy the peaceful surroundings."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual retreat offering meditation programs, wellness therapies, and a serene environment for self-discovery."
    },
    {
      "title": "FC Road and JM Road",
      "description": "Fergusson College Road (FC Road) and Jangali Maharaj Road (JM Road) are bustling streets famous for their shopping, street food, and lively ambiance. From trendy clothes to delicious street snacks, these roads are a paradise for youngsters and shopaholics."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Innova Cab",
      "description": "For travelers heading back to Pune from Mumbai Airport, our Innova cabs provide a comfortable and spacious ride. Book your Mumbai to Pune Innova cab and enjoy a smooth, enjoyable ride after your flight."
    },
    {
      "name": "Mumbai to Pune One-Way Innova",
      "description": "If you're flying into Mumbai Airport and need a one-way ride to Pune, our Innova one-way cab service provides a convenient, comfortable, and cost-effective way to travel. Sit back and relax while we take you to your destination."
    },
    {
      "name": "Private Innova Cab from Pune to Mumbai Airport",
      "description": "Book a private Innova cab for your Pune to Mumbai Airport trip. Whether you’re traveling alone, with family, or in a group, having a private vehicle ensures that you can travel in privacy and comfort."
    },
    {
      "name": "Luxury Innova for Mumbai Airport",
      "description": "For those looking for a luxury ride to Mumbai Airport, our luxury Innova cabs offer premium features such as plush seating, air conditioning, and a smooth ride for a top-tier travel experience. Perfect for business travelers or those looking for extra comfort."
    },
    {
      "name": "Affordable Pune to Mumbai Airport Innova",
      "description": "Travel affordably with an Innova taxi from Pune to Mumbai Airport. We offer competitive prices without compromising on comfort. Whether it’s a solo trip or with family, our affordable Innova taxis ensure great value for money."
    },
    {
      "name": "Group Travel to Mumbai Airport by Innova",
      "description": "Traveling with a group? Our Innova cabs are ideal for group travel to Mumbai Airport. With ample space for luggage and passengers, everyone can travel together in comfort. Book a group travel Innova for a smooth and enjoyable airport trip."
    },
    {
      "name": "Book Innova for Mumbai Airport Pickup",
      "description": "Need a pick-up from Mumbai Airport? Book an Innova for Mumbai Airport pickup and our driver will be waiting for you at the airport with a nameboard, ready to take you to Pune or any other destination."
    },
    {
      "name": "Pune to Mumbai Airport Round Trip Innova",
      "description": "For those who need a round-trip taxi to Mumbai Airport, our Innova cabs offer a great option. Book a round trip to ensure you have a reliable vehicle both ways. Our round-trip service includes pick-up from Pune, a safe journey to the airport, and a return trip after your flight."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Innova Cab", "Mumbai to Pune One-Way Innova"],
    ["Private Innova Cab from Pune to Mumbai Airport", "Luxury Innova for Mumbai Airport"],
    ["Affordable Pune to Mumbai Airport Innova", "Mumbai to Pune Innova Cab"],
    ["Group Travel to Mumbai Airport by Innova", "Pune to Mumbai Airport Round Trip Innova"],
    ["Book Innova for Mumbai Airport Pickup", "Mumbai to Pune Innova Cab"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important it is to reach Pune Airport on time. Whether you're traveling from Mumbai or need a ride from Pune Airport, we ensure prompt pickups from your location and a smooth drive. Our drivers are punctual and committed to getting you to the airport well in advance of your flight."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect choice for traveling from Mumbai to Pune Airport. With comfortable seating, air conditioning, and plenty of space for luggage, you’ll enjoy a relaxing and stress-free journey. Whether you’re traveling alone or with companions, you can expect comfort throughout the ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Pune Airport, ensuring a quick and smooth journey. They are courteous, punctual, and committed to your comfort and safety, making sure you have a hassle-free trip to the airport."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Mumbai to Pune Airport Innova ride. We provide a detailed breakdown of all costs before confirming your booking, with no hidden charges, helping you plan your travel budget accordingly."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. You can travel with peace of mind knowing that your journey to Pune Airport will be secure and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter what time you need to travel, S9 Travels is available 24/7 for your Mumbai to Pune Airport ride. Whether your flight is early in the morning or late at night, we will ensure your ride is ready when you need it, and our customer service team is always available to assist."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Mumbai to Pune Airport Innova cab with S9 Travels is simple and hassle-free. You can book online through our website or mobile app, or you can reach out to our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific preferences or need additional services during your trip, we offer customized travel packages. Whether you need a direct drop-off at the airport or a stop along the way, we’ll tailor the journey to your requirements."
  }
]










    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Pune Airport with S9 Travels?',
            answer: 'Booking a cab for your Mumbai to Pune Airport journey is easy! You can book online through our website or mobile app, or you can reach out to our customer service team for assistance.'
          },
          {
            question: 'What types of cabs are available for Mumbai to Pune Airport travel?',
            answer: 'We offer various types of cabs, including the Toyota Innova, which is perfect for a comfortable and spacious ride. Whether traveling alone or in a group, we have the right vehicle for your needs.'
          },
          {
            question: 'Are the drivers experienced for the Mumbai to Pune Airport route?',
            answer: 'Yes, our drivers are experienced and familiar with the best routes from Mumbai to Pune Airport. They ensure a smooth, safe, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Mumbai to Pune Airport?',
            answer: 'We offer a variety of payment options, including cash, credit/debit cards, and secure online payments through our mobile app for your convenience.'
          },
          {
            question: 'Can I book a round trip from Mumbai to Pune Airport?',
            answer: 'Yes, you can book a round trip. Just provide us with your return details, and we’ll ensure a smooth ride back to Mumbai from Pune Airport.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Extra charges for detours or waiting time, if applicable, will be clearly communicated to you upfront, ensuring full transparency in the pricing.'
          },
          {
            question: 'Can I make additional stops on the way to Pune Airport?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we will accommodate your requests along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Mumbai to Pune Airport trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Mumbai to Pune Airport?',
            answer: 'Yes, we offer corporate travel services for business trips to Pune Airport. Our vehicles are comfortable, and our drivers are professional, ensuring a hassle-free ride.'
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Pune Airport cab booking?',
            answer: 'S9 Travels offers reliable, safe, and comfortable rides with professional drivers, well-maintained vehicles, and excellent customer service, ensuring your journey to Pune Airport is smooth and stress-free.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ravi Kumar',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Pune Airport with S9 Travels, and I was really impressed by their service. The driver was on time, the car was clean, and the ride was smooth and comfortable. Highly recommended for airport transfers!”'
        },
        {
          name: 'Mrs. Swati Gupta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family used S9 Travels for a trip to Pune Airport from Mumbai, and the experience was fantastic. The vehicle was spacious and clean, and the driver was professional. I’ll definitely choose S9 Travels for future airport rides!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Pune Airport Cab",
        "description": "Book reliable and affordable Mumbai to Pune Airport cab services with S9 Travels. Enjoy a hassle-free, comfortable, and safe ride to the airport. Our cabs are available for one-way trips, ensuring timely arrivals and departures. Experience professional drivers, well-maintained vehicles, and flexible schedules for your airport transport needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "8765"
        }
      };
      
      
      
      
      


    return (
        <div>
        <Helmet>
        <title>Mumbai to Pune Airport Cab | Safe & Reliable Taxi Service | S9 Travels</title>
        <meta 
          name="description" 
          content="Book your Mumbai to Pune Airport cab with S9 Travels for a safe, comfortable, and affordable ride. Choose from one-way trips with professional drivers for a hassle-free airport transfer experience." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/88.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneairportcab;